<!-- <ion-content class="ion-padding"> -->
  <div class="flex flex-col gap-y-5 p-4" [formGroup]="form">
    <h3>Boost</h3>
    <ion-input
      fill="outline"
      color="dark"
      labelPlacement="floating"
      label="Points"
      placeholder="Enter amount of points"
      type="number"
      mode="md"
      formControlName="value"
      [errorText]="errorText"
    ></ion-input>
    <ark-button (click)="boost()">Boost</ark-button>
  </div>
<!-- </ion-content> -->
